// extracted by mini-css-extract-plugin
module.exports = {"Content":"styles_Content__Yh4n7","title":"styles_title__OZut0"};